import type { FiboSuggestionItem } from '@/models/fibo/fibosearch';

import { FiboSearchType } from '@/constants/fibo/fibosearch';
import {
  convertToCollectionItem,
  groupFiboSuggestionsToTuples,
} from '@/components/fibosearch/FibosearchCombobox/utils';
import { createListCollection } from '@ark-ui/react/collection';

/**
 * Creates a collection from Fibo suggestions for use in combobox components
 * @param suggestions - The raw suggestions from Fibo search
 * @returns An object containing the collection, groupedCollection, and isGroupedCollection
 */
export const createFiboCollection = (suggestions: FiboSuggestionItem[]) => {
  const convertedCollectionComboboxItems = suggestions.map(convertToCollectionItem);

  const filteredSelectableCollectionItems = convertedCollectionComboboxItems.filter(
    (item) => item.type !== FiboSearchType.HEADLINE,
  );

  //NOTE: We need to use ark-ui's  createListCollection since, fibosearch use ark-ui's combobox
  const collection = createListCollection({
    items: filteredSelectableCollectionItems,
  });

  const groupedCollection = groupFiboSuggestionsToTuples(convertedCollectionComboboxItems);

  const isGroupedCollection = groupedCollection.length > 0;

  return {
    collection,
    groupedCollection,
    isGroupedCollection,
    convertedCollectionComboboxItems,
    filteredSelectableCollectionItems,
  };
};
